import { notification } from 'antd'
import axios from 'axios'

const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getTags: '/messaging/tags?path=',
  setTag: '/messaging/tag',
  getTag: '/messaging/tag',
}

export async function getTags(token, path) {
  // console.log( 'path: ', JSON.stringify(path) );
  const url = fsConfig.root + fsConfig.getTags + path
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      const result = response.data.map((el, ndx) => {
        const o = Object.assign({}, el)
        o.key = `${ndx + 1}`
        return o
      })
      response.data = result
      return response
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo la lista de tags',
        description: error.message,
      })
    })
}

export async function setTag(tag, token) {
  const url = fsConfig.root + fsConfig.setTag
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .post(url, qs.stringify(tag), newConfig)
    .then(response => {
      if (response.status === 201) {
        notification.info({
          message: 'Tag enviado !',
          description: 'El nuevo valor del tag ha sido enviado',
        })
      }
    })
    .catch(error => {
      notification.warning({
        message: 'Error enviando el valor del tag',
        description: error.message,
      })
    })
}
